'use client';

import { IconExitApp } from '@/public/assets/icons/IconExitApp';
import styled from './ExitApp.module.scss';
import { authStore } from '@/shared/store/authStore/authStore';



export function ExitApp() {
  
  async function  handleLogout() {
    const redirectUri = window.location.origin;
    await authStore.async.logout(redirectUri);
  }

  return (
    <button className={styled.root} onClick={handleLogout}>
      <IconExitApp />
      <div className={styled.root_title}>Выйти из системы</div>
    </button>
  );
}
